export default "__VITE_ASSET__C49KHJve__"